import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

import { supabaseClient } from "@/lib/supabase";
import useInvalidateDiaries from "../../diaries/features/edit/api/invalidateDiaries";
import type { ShockwaveDetailSchemaT } from "../components/ShockwaveDetailsForm";
import { deleteShockwaveDetails } from "./deleteShockwaveDetails";
import { ShockwaveDetails } from "../../../types";

type ShockwaveDetailInsert = ShockwaveDetails["Insert"] & {
	shockwave_id: string;
	shockwave_detail_id: string;
};

export async function upsertShockwaveDetail(
	shockwaveDetail: ShockwaveDetailInsert[],
) {
	return await supabaseClient
		.from("shockwave_details")
		.upsert(shockwaveDetail)
		.select()
		.throwOnError()
		.single()
		.then((data) => data.data);
}

export const useReplaceShockwaveDetails = ({
	diaryId,
}: { diaryId: string }) => {
	const invalidateDiaries = useInvalidateDiaries();

	return useMutation({
		mutationFn: async (shockwaveDetail: ShockwaveDetailSchemaT) => {
			await deleteShockwaveDetails(shockwaveDetail.shockwave_id);
			return await upsertShockwaveDetail(
				shockwaveDetail.shockwave_details,
			);
		},
		onError: (error) => {
			toast.error(error.message);
		},
		onSuccess: () => {
			toast.success("shockwave Details Saved");
		},
		onSettled: () => {
			invalidateDiaries(diaryId);
		},
	});
};
